import { render, staticRenderFns } from "./ListRevisionPage.vue?vue&type=template&id=3086ff80"
import script from "./ListRevisionPage.vue?vue&type=script&lang=js"
export * from "./ListRevisionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports